module.exports = __webpack_public_path__ + "img/DS1821+.2732d532.png";